var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7751_225451)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 16.875C6.91142 16.875 4.90838 16.0453 3.43153 14.5685C1.95468 13.0916 1.125 11.0886 1.125 9C1.125 6.91142 1.95468 4.90838 3.43153 3.43153C4.90838 1.95468 6.91142 1.125 9 1.125C11.0886 1.125 13.0916 1.95468 14.5685 3.43153C16.0453 4.90838 16.875 6.91142 16.875 9C16.875 11.0886 16.0453 13.0916 14.5685 14.5685C13.0916 16.0453 11.0886 16.875 9 16.875ZM9 18C11.3869 18 13.6761 17.0518 15.364 15.364C17.0518 13.6761 18 11.3869 18 9C18 6.61305 17.0518 4.32387 15.364 2.63604C13.6761 0.948212 11.3869 0 9 0C6.61305 0 4.32387 0.948212 2.63604 2.63604C0.948212 4.32387 0 6.61305 0 9C0 11.3869 0.948212 13.6761 2.63604 15.364C4.32387 17.0518 6.61305 18 9 18Z",
    fill: "#949494"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0462 7.4115L7.46995 7.73438L7.3777 8.16188L7.88395 8.25525C8.2147 8.334 8.27995 8.45325 8.20795 8.78288L7.3777 12.6844C7.15945 13.6935 7.49582 14.1683 8.2867 14.1683C8.89982 14.1683 9.61195 13.8848 9.93482 13.4955L10.0338 13.0275C9.80882 13.2255 9.48032 13.3043 9.26207 13.3043C8.9527 13.3043 8.8402 13.0871 8.92007 12.7046L10.0462 7.4115ZM10.1249 5.0625C10.1249 5.36087 10.0064 5.64702 9.79544 5.85799C9.58446 6.06897 9.29831 6.1875 8.99995 6.1875C8.70158 6.1875 8.41543 6.06897 8.20445 5.85799C7.99347 5.64702 7.87495 5.36087 7.87495 5.0625C7.87495 4.76413 7.99347 4.47798 8.20445 4.267C8.41543 4.05603 8.70158 3.9375 8.99995 3.9375C9.29831 3.9375 9.58446 4.05603 9.79544 4.267C10.0064 4.47798 10.1249 4.76413 10.1249 5.0625Z",
    fill: "#949494"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7751_225451"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.d3453d6622e1743a8e5359a0d0099672.svg";
export { ForwardRef as ReactComponent };